import React, { useState, useEffect } from "react";
import LayerAdmin from "../LayerAdmin";
import { toast } from "react-toastify";
import ButtonLoader from "../../zamzam/components/ButtonLoader";
import { useNavigate, useParams } from "react-router-dom";
import URL_MAPPING from "../../../routes/constants";
import axios from "axios";

const EditMedia = () => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [invalidFields, setInvalidFields] = useState<string[]>([]);
  const navigate = useNavigate();
  const [filepath, setFilepath] = useState("");
  const { id } = useParams();

  const handleFileChange = (e: any) => {
    setFile(e.target.files[0].name);
  };

  const getInputClass = (field: string) =>
    `w-full border px-3 py-2 rounded ${
      invalidFields.includes(field) ? "border-red-500" : ""
    }`;

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const paramsObj = {
      file: file,
    };

    try {
      setLoading(true);
      const emptyFields = [];
      if (file === null) {
        emptyFields.push("file");
      }

      setInvalidFields(emptyFields);

      if (emptyFields.length > 0) {
        toast.error("Please fill all required fields.");
        return;
      }
      await axios.put(
        `https://staging.sfa.berain.com.sa/web/api/v1/admin/media/${id}`,
        paramsObj
      );
      toast.success("Media updated successfully!");
      navigate(URL_MAPPING.MEDIA);
    } catch (error: any) {
      console.error("Error fetching media data:", error);
      if (error?.response?.status === 404) {
        toast.error("Route not found, Please try again later",{
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
      } else if (error?.response?.status === 500) {
        toast.error("Error while fetching the media",{
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
      } else {
        const detail = error?.response?.data?.detail;
        if (Array.isArray(detail)) {
          detail.forEach((err) => toast.error(err.msg,{
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          }));
        } else {
          toast.error(detail?.msg || detail || "An unexpected error occurred.",{
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          });
        }
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `https://staging.sfa.berain.com.sa/web/api/v1/admin/media/${id}`
        );
        const data = res.data;
        setFilepath(data.file_url);
      } catch (error: any) {
        console.error("Error fetching customer data:", error);
        if (error?.response?.status === 404) {
          toast.error("Route not found, Please try again later");
        } else if (error?.response?.status === 500) {
          toast.error("Error while fetching the employee");
        } else {
          const detail = error?.response?.data?.detail;
          if (Array.isArray(detail)) {
            detail.forEach((err) => toast.error(err.msg));
          } else {
            toast.error(
              detail?.msg || detail || "An unexpected error occurred."
            );
          }
        }
      }
    };
    fetchData();
  }, []);

  return (
    <LayerAdmin>
      <div className="flex items-center px-5 pt-5 gap-3">
        <button
          onClick={() => window.history.back()}
          className="bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
            width="10"
            height="10"
            viewBox="0 0 256 256"
            xmlSpace="preserve"
          >
            <g
              style={{
                stroke: "none",
                strokeWidth: 0,
                strokeDasharray: "none",
                strokeLinecap: "butt",
                strokeLinejoin: "miter",
                strokeMiterlimit: 10,
                fill: "none",
                fillRule: "nonzero",
                opacity: 1,
              }}
              transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
            >
              <polygon
                points="20.48,45 59.75,90 69.52,81.48 37.69,45 69.52,8.52 59.75,0 "
                style={{
                  stroke: "none",
                  strokeWidth: 1,
                  strokeDasharray: "none",
                  strokeLinecap: "butt",
                  strokeLinejoin: "miter",
                  strokeMiterlimit: 10,
                  fill: "rgb(0,0,0)",
                  fillRule: "nonzero",
                  opacity: 1,
                }}
                transform="  matrix(1 0 0 1 0 0) "
              />
            </g>
          </svg>
        </button>
        <h3 className="text-xl font-bold text-gray-700">Edit Media</h3>
      </div>
      <form onSubmit={handleSubmit} className="p-4 lg:w-1/3 sm:w-full">
        <div className="my-2">
          <label className="block font-semibold mb-1">Media ID</label>
          <input name="id" disabled value={id} />
        </div>
<img src={`https:${filepath}`} alt="Media" />
        <div className="my-2">
          <label className="block font-semibold mb-1">File *</label>
          <input
            type="file"
            name="file"
            accept="*"
            onChange={handleFileChange}
            className={getInputClass("file")}
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="bg-teal-500 text-white px-6 py-2 rounded hover:bg-teal-600 flex items-center gap-2"
        >
          Update Media {loading && <ButtonLoader />}
        </button>
      </form>
    </LayerAdmin>
  );
};

export default EditMedia;
